/**
 * @file: Icon.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 设备图标管理
 */
import request from '@/utils/request'

/**
 * 添加图标
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function iconAdd(data) {
  return request({
    type: 'biz',
    url: 'icon/add',
    method: 'post',
    data
  })
}

/**
 * 删除图标
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function iconDelete(data) {
  return request({
    type: 'biz',
    url: 'icon/delete',
    method: 'post',
    data
  })
}

/**
 * 获取图标列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function iconListGet(data) {
  return request({
    type: 'biz',
    url: 'icon/list/get',
    method: 'post',
    data
  })
}

/**
 * 编辑图标
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function iconUpdate(data) {
  return request({
    type: 'biz',
    url: 'icon/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Icon.js